/**
 * Created by maciej on 22/06/2016.
 */
import {app} from '../app';

export interface ISpinnerService {
    spinning:boolean;
    show();
    hide();
}

export class SpinnerService implements ISpinnerService {

    spinning = false;

    constructor() {

    }

    show() {
        this.modal().modal('show');
        this.spinning = true;
    }

    hide() {
        this.modal().modal('hide');
        this.spinning = false;
    }

    private modal():JQuery {
        return angular.element('#loading-modal').modal({
            keyboard: false,
            backdrop: 'static'
        });
    }

    static factory() {
        const factory = () => new SpinnerService();
        factory.$inject = [];
        return factory;
    }

}

app.factory('SpinnerService', SpinnerService.factory());